import { h } from 'preact';
import { useRef, useState } from 'preact/hooks';
import PropTypes from 'prop-types';

import { isMobile } from '../../../../utils/device-utils';
import { useOutsideClick } from '../../../hooks/use-outside-click';
import Option from '../../2-atoms/option/option';
import Select from '../../2-atoms/select/select';

const DropdownFloating = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const handleSelectClick = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useOutsideClick(dropdownRef, handleClose);

  return (
    <div
      className="c-dropdown c-dropdown--floating"
      data-state={isOpen && 'open'}
      ref={dropdownRef}
      onClick={handleSelectClick}
    >
      <div className="c-dropdown__header">
        <Select modifiers={['floating']} noPointerEvents={isMobile()} />
      </div>
      <div className="c-dropdown__body">
        {options.map((option, i) => (
          <Option
            key={i}
            modifiers={option.hasArrow ? ['floating', 'floating-with-arrow'] : ['floating']}
            tag="a"
            target={option.target}
            href={option.href}
            onClick={option.onClick}
            text={option.text}
            intcmp={option.intcmp}
          />
        ))}
      </div>
    </div>
  );
};

DropdownFloating.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      href: PropTypes.string,
      target: PropTypes.string,
      intcmp: PropTypes.string,
      hasArrow: PropTypes.bool,
    })
  ),
};

export default DropdownFloating;
